import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    StarInterestDirective
} from './directives';
import {
    AutocompletableTextareaModule,
    StandardizedSidePanelModule
} from './modules';
import { MarkdownDirective } from './markdown/markdown.directive';
import { AngularJSManagedFolderContentsView } from './managed-folders/angularjs-managed-folder-contents-view.directive';
import { ManagedFolderContentsViewComponent } from './managed-folders/managed-folder-contents-view.component';
import { RelatedByTypeComponent } from './catalog/related-by-type.component';
import { UiGlobalTag } from './tags/ui-global-tag.directive';
import { DatasetStatusComponent } from './datasets/dataset-status.component';

@NgModule({
    imports: [
        CommonModule,
        AutocompletableTextareaModule,
        StandardizedSidePanelModule
    ],
    declarations: [
        MarkdownDirective,
        AngularJSManagedFolderContentsView,
        ManagedFolderContentsViewComponent,
        StarInterestDirective,
        RelatedByTypeComponent,
        UiGlobalTag,
        DatasetStatusComponent
    ],
    exports: [
        MarkdownDirective,
        ManagedFolderContentsViewComponent,
        StarInterestDirective,
        RelatedByTypeComponent,
        UiGlobalTag,
        DatasetStatusComponent
    ],
})
export class MigrationModule { }
